export default __webpack_public_path__ + "static/media/upload.5691e16c.svg";